import { createAsyncThunk } from "@reduxjs/toolkit";
import plansApi from "api/planApi";
import sectionApi from "api/sectionApi";
import { formatQueryParams } from "helpers/format";

export const getSections = createAsyncThunk("Sections", async (params: any = {}) => {
  try {
    const response = await sectionApi.getSections(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const createSection = async (data: any = {}) => {
  try {
    const response = await sectionApi.postSection(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const updateSection = async (id: string | number, data: any = {}) => {
  try {
    const response = await sectionApi.putSection(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateItemSection = async (data: any = {}) => {
  try {
    const response = await sectionApi.putItemSection(data);
    return response;
  } catch (error) {
    return error;
  }
};
